<template>
  <div class="container">
    <div class="d-flex flex-column flex-fill">
      <FilterComp />
      <div
        class="accordion d-flex flex-column flex-fill"
        id="things"
        ref="accordian"
      >
        {{ newApplications }}
        <AccordianComp title="New" total="1" :closed="false">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="In Review" total="0" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Deferred" total="7" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Approved (Pending)" total="29" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Approved" total="4" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Expired" total="1" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Declined" total="13" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Contract Signed" total="8" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
        <AccordianComp title="Completed" total="0" :closed="true">
          <template #content>
            <TableComp />
            <PaginationControlsComp />
          </template>
        </AccordianComp>
      </div>
    </div>
  </div>
</template>

<script>
import FilterComp from "@/components/FilterComp.vue";
import AccordianComp from "@/components/AccordianComp.vue";
import TableComp from "@/components/TableComp.vue";
import PaginationControlsComp from "@/components/PaginationControlsComp.vue";

export default {
  name: "ApplicationView",
  components: { FilterComp, AccordianComp, TableComp, PaginationControlsComp },
  mounted() {
    console.log(this.$store);
    // this.$store.dispatch("applications/getApplications");
  },
  computed: {
    newApplications() {
      return this.$store.state.applications.new;
    },
  },
  methods: {},
};
</script>

<style scoped>
[accordian-button] {
  aspect-ratio: 1;
}
[app-accrodian-title] {
  line-height: 0px;
}
</style>
